export function priceIntersectsFirstCandleFilterParser(root, softOrder) {

  return;
}
/*
{
    "messageType": "softOrder",
    "tradePlanId": 1643309263277,
    "tradePlanType": "ALERT",
    "value": {
        "timeStamp": "1643309263316",
        "tacticId": "AMDPRICE_INTERSECTS_FIRST_CANDLE16433092632771",
        "tactic": "PRICE_INTERSECTS_FIRST_CANDLE",
        "symbol": "AMD",
        "tacticValue": {
            "priceToBreak": 101,
            "candleDuration": 15
        }
    }
}
*/
